/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useTheme from '@mui/system/useTheme';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
// import { AdapterMomentJalaali } from '@mui/x-date-pickers/AdapterMomentJalaali';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { faIR } from '@mui/x-date-pickers/locales';
import './jalaliCalender.css'

  
export function FormatDate(date: any) {
  let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

interface AdapterJalaliProps {
    label?: string;
    date: Date;
    dateChangeHandler: (date: Date | null) => void;
}
export const AdapterJalali: FC<AdapterJalaliProps> = ({ 
  label, 
  date, 
  dateChangeHandler 
}) => {
  const existingTheme = useTheme();
  const theme = React.useMemo(
    () => createTheme({ direction: 'rtl' }, existingTheme),
    [existingTheme],
  );

  return (
    <ThemeProvider theme={theme}>
      <div dir="rtl">
        <LocalizationProvider 
          dateAdapter={AdapterDateFnsJalali}
          localeText={faIR.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <DatePicker 
            label={label} 
            value={date} 
            onChange={dateChangeHandler}
            sx={{ 
              // mt:1,    
              width:120, 
              "& .MuiOutlinedInput-input": {
                textAlign:'left',
              }
              // "& .MuiInputLabel-outlined": { fontFamily: 'B Nazanin', border:'.5px solid red'},
              // "& .MuiLabel-label": { fontFamily: 'B Nazanin' , border:'.5px solid red'},
              // "& .MuiPickersCalendarHeader-root": {color: 'aliceblue', border:'.5px solid red'}
            }}
            slotProps={{ textField: { size: 'small' } }}
            className='custom-calendar'
            dayOfWeekFormatter={(day) => `${day}`}
          />
        </LocalizationProvider>
      </div>
    </ThemeProvider>
  );
}
